<template>
  <SelectboxBase
    v-model:show="showOption"
    v-model:selected="itemSelected"
    :type="type"
    v-ClickOutside="closeSelect"
  >
    <template #select>
      <input
        type="search"
        class="custom-search bd-n fs-14 lh-17 outline-0 hand bg-transparent db wp-100 hp-100 absolute left-0 top-0 pl-40 pr-16"
        :placeholder="placeholder"
        v-model="searchQuery"
        @keyup.enter="handleEnterKey()"
        autocomplete="autocomplete-box"
      />
      <span class="absolute right-20" @click="handleDeselect">
        <img src="https://s3-cdn.designerjourneys.com/static/icons/icon-menu.svg"  v-if="itemSelected" />
      </span>
    </template>
    <template v-if="popularDestinations.length" #select-option>
      <div v-if="searchQuery">
        <div v-if="searchedOptions.length">
          <div
            v-for="(item, index) in searchedOptions"
            :key="index"
            class="custom-option-item"
            @click="onChangeOption(item)"
          >
            <div v-html="highlightText(item.name)"></div>
          </div>
        </div>
        <div v-else class="fs-12 lh-16 pt-8 pb-8 pl-16 pr-16 fw-600-arial">
          No results
        </div>
<!--        <div class="pl-16 pr-16 mt-10">-->
<!--          <div class="bd-gray-dark bd-t-1 pt-14 pb-8">-->
<!--            <img src="https://s3-cdn.designerjourneys.com/static/images/general/google.png" alt="google" />-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div v-else>
        <div v-if="!($route.name === 'gallery-enquiry-steps' || $route.name === 'enquiry-steps' || $route.name === 'trip-gallery' || $route.name === 'home' || $route.name === 'dashboard-agent')"
             class="fs-14 lh-16 pt-8 pb-8 pl-16 pr-16 fw-600-arial">
          Popular Destinations
        </div>

        <template v-if='isGlobalGallery'>
          <div v-for="(item, index) in popularDestinations" :key='index'>
            <div v-if='item.title' class="fs-14 lh-16 pt-8 pb-8 pl-16 pr-16 fw-600-arial">{{item.title}}</div>
            <div
              v-for="(subItem, idx) in item.items"
              :key="idx"
              class="custom-option-item hand"
              @click="onChangeOption(subItem)"
            >
              <span>{{ subItem.name }}</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div
            v-for="(item, index) in popularDestinations"
            :key="index"
            class="custom-option-item hand"
            @click="onChangeOption(item)"
          >
            <span>{{ item.name }}</span>
          </div>
        </template>
<!--        <div class="pl-16 pr-16 mt-10">-->
<!--          <div class="bd-gray-dark bd-t-1 pt-14 pb-8">-->
<!--            <img src="https://s3-cdn.designerjourneys.com/static/images/general/google.png" alt="google" />-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </template>
  </SelectboxBase>
</template>

<script>
import { ref, computed, defineComponent, watch, watchEffect } from 'vue'
import SelectboxBase from '~/components/ui/selectbox/SelectboxBase'
import ClickOutside from '~/directives/ClickOutside'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'Autocomplete',
  directives: {
    ClickOutside,
  },
  components: { SelectboxBase },
  emits: ['update:optionSelected', 'trigger', 'deselect'],
  props: {
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    popularDestinations: {
      type: Array,
      default: null,
    },
    options: {
      type: Array,
      default: null,
    },
    optionSelected: {
      type: [Array, Object],
      default: null,
    },
    tabindex: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const showOption = ref(false)
    const itemSelected = ref(false)
    const dataSelected = ref()
    const searchQuery = ref('')
    const route = useRoute()

    const onChangeOption = (item) => {
      searchQuery.value = item.name
      itemSelected.value = true
      showOption.value = false
      emit('update:optionSelected', item)
      emit('trigger')
    }

    const closeSelect = () => {
      showOption.value = false
    }

    const handleDeselect = () =>{
      searchQuery.value = ''
      itemSelected.value = false
      emit('deselect', '')
      showOption.value = true
    }

    const handleEnterKey = () => {
      if(searchedOptions.value.length && searchQuery.value) {
        onChangeOption(searchedOptions.value[0])
      } else return;
    }

    const searchedOptions = computed(() => {
      return props.options.filter((option) => {
        return (
          option.name.toLowerCase().indexOf(searchQuery.value.toLowerCase()) !=-1
        )
      }).sort((a,b) => a.name.length - b.name.length)
    })

    const highlightText = (text) => {
      let query = searchQuery.value.endsWith(`\\`) ? searchQuery.value.slice(0, -1) : searchQuery.value
      return text.replace(new RegExp(query, 'gi'), (match) => {
        return '<span class="highlighted">' + match + '</span>'
      })
    }

    watchEffect(()=>{
      if(route.query.destination){
        itemSelected.value = true
      } else{
        itemSelected.value = false
      }
    })

    watch(
      () => props.optionSelected,
      (value) => {
        searchQuery.value = value.name
      },
    )

    const isGlobalGallery = computed(() => {
      if(route.name === 'trip-gallery' || route.name === 'home' || route.name === 'dashboard-agent' || route.name === 'gallery-enquiry-steps' || route.name === 'enquiry-steps') return true
      return false
    })

    return {
      showOption,
      onChangeOption,
      closeSelect,
      itemSelected,
      dataSelected,
      searchQuery,
      searchedOptions,
      highlightText,
      handleDeselect,
      isGlobalGallery,
      handleEnterKey
    }
  },
})
</script>

<style lang="scss" scoped>
</style>
